export enum PasswordSecurityActionType {
  FETCH_PASSWORD_SECURITY_REQUEST = 'passwordSecurity/FETCH_PASSWORD_SECURITY_REQUEST',
  FETCH_PASSWORD_SECURITY_SUCCESS = 'passwordSecurity/FETCH_PASSWORD_SECURITY_SUCCESS',
  FETCH_PASSWORD_SECURITY_FAILURE = 'passwordSecurity/FETCH_PASSWORD_SECURITY_FAILURE',
  PUT_PASSWORD_SECURITY_REQUEST = 'passwordSecurity/PUT_PASSWORD_SECURITY_REQUEST',
  PUT_PASSWORD_SECURITY_SUCCESS = 'passwordSecurity/PUT_PASSWORD_SECURITY_SUCCESS',
  PUT_PASSWORD_SECURITY_FAILURE = 'passwordSecurity/PUT_PASSWORD_SECURITY_FAILURE',
}
